module.exports = __webpack_public_path__ + "img/icone-sorveteria.92720e50.svg";